/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState } from 'react'
import { Table, Divider, Row, Col, Button, Modal, Select, Card } from 'antd'
import styles from './index.less'
import moment from 'moment'
import PreviewModal from '@/components/PreviewModal'
import { REFUND_METHODS, REFUND_METHODS_SHOW, REFUND_TYPE_OBJ, REFUNT_STATUS } from '@/utils/consts'

const { Option } = Select

const ReserveInfo = ({ data }) => {

  // console.log(data)
  const [visible,setVisible] = useState(false);
  const [imgUrl,setImgUrl] = useState([]);

  const columns = [
    {
      dataIndex: 'refundDate',
      title: '退款日期',
      width: 100,
      align: 'center',
      render(text) {
        return text ? moment(text).format('YYYY-MM-DD') : undefined
      }
    },
    {
      dataIndex: 'refundCategory',
      title: '退款方式',
      width: 100,
      align: 'center',
      render(text) {
        return text ? REFUND_TYPE_OBJ[text] : undefined
      }
    },
    {
      dataIndex: 'paymentMethod',
      title: '支付类型',
      width: 100,
      align: 'center',
      render(text) {
        return text ? REFUND_METHODS_SHOW.filter(_ => _.value === text)[0].name : undefined
      }
    },
    {
      dataIndex: 'amount',
      title: '退款金额',
      width: 100,
      align: 'center',
      render: amount => amount && amount >= 0 ? amount.toFixed(2) + '元' : undefined,
    },
    {
      dataIndex: 'deductAmount',
      title: '不退金额',
      width: 100,
      align: 'center',
      render: deductAmount => deductAmount && deductAmount >= 0 ? deductAmount + '元' : undefined,
    },
    {
      dataIndex: 'financialConfirmer',
      title: '财务确认人',
      width: 100,
      align: 'center',
    },
    {
      dataIndex: 'comment',
      title: '退款原因',
      width: 140,
      ellipsis: true,
      align: 'center',
    },
    {
      dataIndex: 'attachment',
      title: '退款凭证',
      width: 140,
      ellipsis: true,
      align: 'center',
      render:(text)=>{
        return  <Button type="link" disabled={text?false:true} onClick={()=>{setVisible(true);let temp = (text&&text.split(','))||[];setImgUrl(temp)}}>查看</Button>
      }
    },
    {
      dataIndex: 'status',
      title: '退款状态',
      width: 80,
      ellipsis: true,
      align: 'center',
      render(text) {
        return text ? REFUNT_STATUS.filter(_ => _.value === text)[0].label : undefined
      }
    },
    {
      dataIndex: 'createdAt',
      title: '创建时间',
      width: 100,
      align: 'center',
      render(text) {
        return text && moment(text).format('YYYY-MM-DD')
      }
    }
  ]

  return (
    <div className={styles.reserve}>
      <Card title='退款信息' size='small' style={{marginTop: 10}} bordered={false}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        defaultExpandAllRows={true}
        scroll= {{ x: 1150 }}
        expandedRowRender={expandedRowRender}
        expandIcon={({expanded, onExpand, record}) => record.refundOrderItemReqs ? <span className='icon-wrapper'><span className={expanded ? 'icon-expanded' : 'icon-collapse' } onClick={onExpand} /></span> : null}
        size="small"
        rowKey="id"
      />
      </Card>
      {/* <Modal
        visible={visible}
        title='退款凭证'
        footer={null}
        onCancel={()=>{setVisible(false);setImgUrl([])}}
      >
        {imgUrl&&imgUrl.map((item)=>{
          return <img style={{width:'100%'}} src={item} alt='退款凭证'/>
        })}
      </Modal> */}
      <PreviewModal 
        visible={visible} 
        onCancel={()=>{setVisible(false);setImgUrl([])}}
        imgArray={imgUrl}
        title='退款凭证'
      />
    </div>
  )
}

export default ReserveInfo

function expandedRowRender(record) {
  const columns = [
    // {
    //   title: '商品类别',
    //   key: 'productCategoryName',
    //   render: (_, record) => (record.categoryList || []).map(_ => _.name).join('/')
    // },
    {
      title: '商品名称',
      dataIndex: 'orderItem',
      render: orderItem => orderItem && orderItem.name
    },
    {
      title: '服务频次',
      dataIndex: 'productVo',
      width: 80,
      align: 'right',
      render: (product, record) => (product || {}).quantity
    },
    {
      title: '商品定价',
      dataIndex: 'productVo',
      width: 100,
      align: 'right',
      render: (product) => product && product.price > 0 ? product.price + '元' : undefined
    },
    {
      title: '数量',
      dataIndex: 'orderItem',
      width: 80,
      align: 'right',
      render: (orderItem) => orderItem && orderItem.quantity
    },
    // {
    //   title: '折扣',
    //   dataIndex: 'orderItem',
    //   width: 100,
    //   align: 'right',
    //   render: orderItem => orderItem && orderItem.discount <= 1 ? Number(orderItem.discount * 100).toFixed(2) + '%' : undefined
    // },
    // {
    //   title: '折后金额',
    //   dataIndex: 'orderItem',
    //   width: 100,
    //   align: 'right',
    //   render: (orderItem) => orderItem && orderItem.discountPrice >= 0 ? orderItem.discountPrice + '元' : undefined
    // },
    // {
    //   title: '折后立减',
    //   dataIndex: 'orderItem',
    //   width: 100,
    //   align: 'right',
    //   render: (orderItem) => orderItem && orderItem.amount > 0 ? orderItem.amount + '元' : '0.00元'
    // },
    // {
    //   title: '单项收款',
    //   dataIndex: 'orderItem',
    //   width: 100,
    //   align: 'right',
    //   render: (orderItem) => orderItem && orderItem.amount > 0 ? orderItem.amount + '元' : undefined
    // },
    {
      title: '分摊实收明细',
      dataIndex: 'orderItem',
      width: 100,
      align: 'right',
      render: (orderItem) => orderItem && orderItem.realAmount > 0 ? orderItem.realAmount + '元' : undefined
    },
    {
      title: '总服务次数',
      dataIndex: 'orderItem',
      width: 100,
      align: 'right',
      render: (orderItem) => orderItem && orderItem.totalCount
    },
    {
      title: '已消耗次数',
      dataIndex: 'orderItem',
      width: 100,
      align: 'right',
      render: (orderItem) => orderItem && orderItem.consumptionCount
    },
    {
      title: '退款次数',
      dataIndex: 'refundQuantity',
      width: 80,
      align: 'right',
    },
    {
      title: '应退金额',
      dataIndex: 'refundAmount',
      width: 100,
      align: 'right',
    },
    {
      title: '实退金额',
      dataIndex: 'realRefundAmount',
      width: 100,
      align: 'right',
    },
    {
      title: '不退金额',
      dataIndex: 'deductAmount',
      width: 100,
      align: 'right',
    },
  ]

  if(record.refundOrderItemReqs) {
    return (
    <Fragment>
      <h4 className='order-items-label'>退款明细</h4>
      <Table columns={columns} pagination={false} bordered={false} dataSource={record.refundOrderItemReqs || []} size='small'/>
    </Fragment>)
  }else {
    return false
  }
};
